// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../../node_modules/.pnpm/css-loader@7.1.5_webpack@5.111.1/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../node_modules/.pnpm/css-loader@7.1.5_webpack@5.111.1/node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../../../../../../../node_modules/.pnpm/css-loader@7.1.5_webpack@5.111.1/node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[5].use[1]!./CheckboxTokens.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* stylelint-disable selector-max-specificity -- design system */
/* stylelint-disable property-disallowed-list -- design system */

.CheckboxInput-module__Container__BTHuJ {
    display: flex;
    flex-direction: row;
    align-items: center;
    cursor: pointer;
    user-select: none;
}

.CheckboxInput-module__Disabled__NEYX9 {
    cursor: default;
}

.CheckboxInput-module__Default__uymfT {
    gap: var(--ds-gap-m);
    padding: var(--ds-sm) var(--ds-m);
    background-color: var(--ds-checkbox-input-bg-color);
    border-color: var(--ds-checkbox-input-border-color);
    border-style: solid;
    border-width: var(--ds-border-width);
    border-radius: var(--ds-border-radius-sm);
}

.CheckboxInput-module__Default__uymfT:hover {
    border-color: var(--ds-checkbox-input-hover-border-color);
}

.CheckboxInput-module__Disabled__NEYX9:hover {
    border-color: var(--ds-checkbox-input-border-color);
}

.CheckboxInput-module__Compact__mHTJe {
    gap: var(--ds-gap-s);
    padding: var(--ds-s);
    border: none;
    border-radius: var(--ds-border-radius-s);
}

.CheckboxInput-module__CheckboxWrapper__YTPnZ {
    display: flex;
    align-items: center;
    justify-content: center;
    min-width: var(--ds-5x);
    max-width: var(--ds-5x);
    min-height: var(--ds-5x);
    max-height: var(--ds-5x);
    background-color: var(--ds-checkbox-input-bg-color);
    border-color: var(--ds-checkbox-border-color);
    border-style: solid;
    border-width: var(--ds-border-width-focus);
    border-radius: var(--ds-border-radius-xs);
}

.CheckboxInput-module__CheckboxWrapperChecked__wREuQ {
    border-color: var(--ds-checkbox-selected-border-color);
}

.CheckboxInput-module__CheckboxWrapperFocused__oNxM9 {
    border-color: var(--ds-checkbox-selected-fill);
}

.CheckboxInput-module__Container__BTHuJ:hover .CheckboxInput-module__CheckboxWrapper__YTPnZ {
    border-color: var(--ds-checkbox-hover-border-color);
}

.CheckboxInput-module__Container__BTHuJ:hover .CheckboxInput-module__CheckboxWrapperChecked__wREuQ {
    border-color: var(--ds-checkbox-selected-border-color);
}

.CheckboxInput-module__CheckboxWrapperDisabled__KrzjN {
    border-color: var(--ds-checkbox-border-color);
}

.CheckboxInput-module__Disabled__NEYX9:hover .CheckboxInput-module__CheckboxWrapperDisabled__KrzjN {
    border-color: var(--ds-checkbox-border-color);
}

.CheckboxInput-module__Disabled__NEYX9 .CheckboxInput-module__CheckboxChecked__eE1Ll {
    background-color: var(--ds-checkbox-input-disabled-color);
}

.CheckboxInput-module__Checkbox__MlC4g {
    outline: none;
    cursor: pointer;
    appearance: none;
}

.CheckboxInput-module__CheckboxDisabled__ppgo2 {
    cursor: default;
}

.CheckboxInput-module__CheckboxChecked__eE1Ll {
    width: calc(var(--ds-5x) / 2);
    height: calc(var(--ds-5x) / 2);
    background-color: var(--ds-checkbox-selected-fill);
    border: none;
    border-radius: var(--ds-05x);
}

.CheckboxInput-module__Details__DynC6 {
    display: flex;
    flex-direction: column;
    gap: var(--ds-gap-xs);
}

.CheckboxInput-module__Label__to8R5 {
    color: var(--ds-checkbox-input-color);
    font-weight: var(--ds-font-weight-bold);
    font-size: var(--ds-font-size-s);
    line-height: var(--ds-line-height);
}

.CheckboxInput-module__Disabled__NEYX9 .CheckboxInput-module__Label__to8R5 {
    color: var(--ds-checkbox-input-disabled-color);
}

.CheckboxInput-module__Description__Sa_r8 {
    color: var(--ds-checkbox-input-description-color);
    font-weight: var(--ds-font-weight-medium);
    font-size: var(--ds-font-size-s);
    line-height: var(--ds-line-height);
}

.CheckboxInput-module__Disabled__NEYX9 .CheckboxInput-module__Description__Sa_r8 {
    color: var(--ds-checkbox-input-disabled-color);
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"Container": `CheckboxInput-module__Container__BTHuJ`,
	"Disabled": `CheckboxInput-module__Disabled__NEYX9`,
	"Default": `CheckboxInput-module__Default__uymfT`,
	"Compact": `CheckboxInput-module__Compact__mHTJe`,
	"CheckboxWrapper": `CheckboxInput-module__CheckboxWrapper__YTPnZ`,
	"CheckboxWrapperChecked": `CheckboxInput-module__CheckboxWrapperChecked__wREuQ`,
	"CheckboxWrapperFocused": `CheckboxInput-module__CheckboxWrapperFocused__oNxM9`,
	"CheckboxWrapperDisabled": `CheckboxInput-module__CheckboxWrapperDisabled__KrzjN`,
	"CheckboxChecked": `CheckboxInput-module__CheckboxChecked__eE1Ll`,
	"Checkbox": `CheckboxInput-module__Checkbox__MlC4g`,
	"CheckboxDisabled": `CheckboxInput-module__CheckboxDisabled__ppgo2`,
	"Details": `CheckboxInput-module__Details__DynC6`,
	"Label": `CheckboxInput-module__Label__to8R5`,
	"Description": `CheckboxInput-module__Description__Sa_r8`
};
export default ___CSS_LOADER_EXPORT___;
